import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link, useParams } from "react-router-dom";
import Footer from ".././Footer";
import Navbar from ".././Navbar";
import { openBusinessWhatsApp } from "../../helper/HelperUtils";
import { sendViewEvent } from "../../services/AppscasaAnalytics";
import { products } from "./productsData";

const ProductDetails = () => {
  const { slug } = useParams();
  const product = products.find((item) => item.slug === slug);

  const navigateToBusinessAccount = (requestType) => {
    if (!product) return;

    const requestDate = new Date().toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    const productLink = window.location.href;

    openBusinessWhatsApp(
      `Hello Appscasa Team,\n\nI would like to enquire about the following product:\n\n- *Request Type:* ${requestType}\n- *Product:* ${product.title}\n- *Request Date:* ${requestDate}\n- *Price:* ${product.price}\n- *Product Link:* ${productLink}\n\nKindly share the next steps and related details.`
    );
  };

  useEffect(() => {
    sendViewEvent(window.location.pathname);
  }, []);

  if (!product) {
    return (
      <>
        <Navbar />
        <section className="section-padding bg-gray">
          <div className="container">
            <h4 className="mb-3">Product Not Found</h4>
            <Link to="/products" className="butn butn-bg">
              <span>Back To Products</span>
            </Link>
          </div>
        </section>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{product.title}</title>
        <meta name="description" content={product.description} />
      </Helmet>
      <Navbar />

      <header
        className="pages valign bg-img parallaxie"
        data-background="/assets/img/bg.jpg"
        data-overlay-dark={7}
      >
        <div className="container">
          <div className="row">
            <div className="full-width mt-80">
              <h5>{product.title}</h5>
              <h6>
                <Link to="/">Home</Link>/
                <Link to="/products">Products</Link>/
                <span className="active">Details</span>
              </h6>
            </div>
          </div>
        </div>
      </header>

      <section className="products-section section-padding bg-gray">
        <div className="container">
          <div className="row g-5 align-items-start">
            <div className="col-lg-8">
              <div className="product-preview-panel">
                <img
                  src={product.image}
                  alt={product.title}
                  className="product-preview-image"
                />
                <div className="product-preview-actions">
                  {/* <button type="button" className="preview-action-button">
                    <span>Screenshots</span>
                  </button> */}
                  <button
                    type="button"
                    className="preview-action-button"
                    onClick={() => {
                      if (product.videoUrl) {
                        window.open(
                          product.videoUrl,
                          "_blank",
                          "noopener,noreferrer"
                        );
                      }
                    }}
                    disabled={!product.videoUrl}
                  >
                    <span>Video</span>
                  </button>
                </div>
              </div>

              <section className="product-about-panel">
                <h5>About Product</h5>
                <p>{product.longDescription}</p>
              </section>

              <div className="product-demo-panel">
                <h5>Product Demo Preview</h5>
                <div className="product-demo-frame">
                  <img
                    src={product.demoGif}
                    alt={`${product.title} demo`}
                    className="product-demo-gif"
                  />
                </div>
              </div>

              <div className="product-help-actions">
                <button
                  type="button"
                  className="product-help-card"
                  onClick={() => navigateToBusinessAccount("Get Support")}
                >
                  <span className="product-help-icon support-icon">
                    <span />
                    <span />
                  </span>
                  <span>Get Support</span>
                </button>
                <button
                  type="button"
                  className="product-help-card"
                  onClick={() => {
                    if (product.documentationUrl) {
                      window.open(
                        product.documentationUrl,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }
                  }}
                  disabled={!product.documentationUrl}
                >
                  <span className="product-help-icon docs-icon">
                    <span />
                    <span />
                  </span>
                  <span>Documentation</span>
                </button>
                <button
                  type="button"
                  className="product-help-card"
                  onClick={() =>
                    navigateToBusinessAccount("Pre-Sales Question")
                  }
                >
                  <span className="product-help-icon question-icon">
                    <span>?</span>
                  </span>
                  <span>Pre-Sales Questions?</span>
                </button>
              </div>

              <p className="product-apk-note">
                Demo APK available for Android devices only. Try it before
                purchase to review the product experience.
              </p>
              <a
                href={product.apkUrl}
                download
                className="product-apk-download"
              >
                <span className="product-android-icon" aria-hidden="true">
                  <span />
                </span>
                <span>Download APK</span>
              </a>

              <section className="product-features-panel">
                <h5>Product Features</h5>
                <ul>
                  {product.features.map((feature) => (
                    <li key={feature}>
                      <span aria-hidden="true">✓</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </section>

              <section className="product-deliverables-panel">
                <h5>What You Will Get</h5>
                <div className="product-deliverables-list">
                  {product.deliverables.map((item) => (
                    <article key={item.title} className="product-deliverable">
                      <span className="product-deliverable-icon" aria-hidden="true">
                        ✓
                      </span>
                      <div>
                        <h6>{item.title}</h6>
                        <p>{item.description}</p>
                      </div>
                    </article>
                  ))}
                </div>
              </section>

              <section className="product-purchase-flow-panel">
                <h5>How Purchase Works</h5>
                <ol>
                  <li>
                    <span>1</span>
                    <p>
                      <strong>Send your request</strong>
                      Click Request To Buy to start the purchase conversation.
                    </p>
                  </li>
                  <li>
                    <span>2</span>
                    <p>
                      <strong>Confirm details on WhatsApp</strong>
                      Appscasa confirms the product, license, and buyer
                      requirements.
                    </p>
                  </li>
                  <li>
                    <span>3</span>
                    <p>
                      <strong>Complete payment</strong>
                      Appscasa shares a secure payment link or verified payment
                      details.
                    </p>
                  </li>
                  <li>
                    <span>4</span>
                    <p>
                      <strong>Receive product files</strong>
                      After payment confirmation, you receive source code,
                      invoice, documentation, and delivery details.
                    </p>
                  </li>
                  <li>
                    <span>5</span>
                    <p>
                      <strong>Get ongoing support</strong>
                      A support email
                      thread is created for future technical support.
                    </p>
                  </li>
                </ol>
              </section>

              <section className="product-requirements-panel">
                <h5>Module Requirements</h5>
                <p>
                  Make sure your mobile app project includes the following
                  requirements before integration.
                </p>
                <ul>
                  {product.productRequirements.map((requirement) => (
                    <li key={requirement}>
                      <span aria-hidden="true">✓</span>
                      <span>{requirement}</span>
                    </li>
                  ))}
                </ul>
              </section>
            </div>

            <div className="col-lg-4">
              <aside className="product-buy-panel">
                <div className="product-license-row">
                  <div className="product-license-label">Regular License</div>
                  <div className="product-price">
                    <span>$</span>
                    <strong>{product.price.replace("$", "")}</strong>
                  </div>
                </div>

                <div className="product-license-summary">
                  <p>
                    This license is valid for one application or project owned
                    by you or your client.
                  </p>

                  <h6>Included</h6>
                  <ul className="product-license-list">
                    <li>
                      <span className="license-allowed">✓</span>
                      <span>Use the product in a single app or project</span>
                    </li>
                    <li>
                      <span className="license-allowed">✓</span>
                      <span>Customize and modify the source code as needed</span>
                    </li>
                    <li>
                      <span className="license-allowed">✓</span>
                      <span>
                        Share access with your team for the same project
                      </span>
                    </li>
                  </ul>

                  <h6>Restrictions</h6>
                  <ul className="product-license-list">
                    <li>
                      <span className="license-denied">×</span>
                      <span>Reuse across multiple apps or projects</span>
                    </li>
                    <li>
                      <span className="license-denied">×</span>
                      <span>Resell, redistribute, or publicly share the files</span>
                    </li>
                  </ul>
                </div>

                <button
                  type="button"
                  className="product-cart-button product-cart-button-elevated"
                  onClick={() => navigateToBusinessAccount("Request To Buy")}
                >
                  <span>Request To Buy</span>
                </button>

                <p className="product-buy-help-text">
                 Our team will contact you on WhatsApp regarding the payment and delivery details.
                </p>

                <button
                  type="button"
                  className="product-cart-button product-cart-button-elevated mt-5 bg-warning"
                  onClick={() =>
                    navigateToBusinessAccount("Request For Customization")
                  }
                >
                  <span>Request For Customization</span>
                </button>

                <p className="product-buy-help-text">
                  Need branding, feature changes, or setup help? Request
                  customization.
                </p>

                <p className="product-price-note">
                  Price is in US dollars and excludes tax and handling fees
                </p>
              </aside>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ProductDetails;
